'use client';

import { FormEventHandler } from 'react';
import { UIPriority } from '@/enums/ui-priorities';
import Button from '@/ui/Button';
import Input from '@/ui/Input';
import Modal from '@/ui/Modal';

type GroupMergeNameModalProps = {
    isShown: boolean;
    entityLabel: 'продуктов' | 'брендов';
    groupNameDraft: string;
    onGroupNameDraftChange: (value: string) => void;
    onSubmit: FormEventHandler<HTMLFormElement>;
    onClose: () => void;
    isSubmitting: boolean;
    isSubmitDisabled: boolean;
};

export const GroupMergeNameModal = ({
    isShown,
    entityLabel,
    groupNameDraft,
    onGroupNameDraftChange,
    onSubmit,
    onClose,
    isSubmitting,
    isSubmitDisabled,
}: GroupMergeNameModalProps) => {
    return (
        <Modal
            isShown={isShown}
            setIsShown={(isVisible) => {
                if (!isVisible) {
                    onClose();
                }
            }}
            title={`Объединение групп ${entityLabel}`}
            closable={true}
            className="h-auto max-h-[90vh] w-[min(520px,96vw)]"
        >
            <form aria-label="Форма объединения групп" className="flex w-full flex-col gap-3 p-4" onSubmit={onSubmit}>
                <p className="text-sm text-slate-600">Укажите название для новой объединённой группы.</p>
                <label className="flex flex-col gap-1 text-xs text-slate-500">
                    Название новой группы
                    <Input
                        id="group-merge-name-input"
                        aria-label="Название новой группы"
                        value={groupNameDraft}
                        onChange={(event) => onGroupNameDraftChange(event.target.value)}
                        autoFocus={true}
                    />
                </label>
                <div className="flex items-center justify-end gap-2">
                    <Button type="button" priorityType={UIPriority.SECONDARY} className="w-[120px]" onClick={onClose}>
                        Отмена
                    </Button>
                    <Button
                        type="submit"
                        priorityType={UIPriority.PRIMARY}
                        className="w-[140px]"
                        disabled={isSubmitDisabled || isSubmitting}
                    >
                        {isSubmitting ? 'Группируем...' : 'Группировать'}
                    </Button>
                </div>
            </form>
        </Modal>
    );
};
